module.exports = __webpack_public_path__ + "a669b83c3a1880a8c877080753a725b7.svg";